import useTranslation from "next-translate/useTranslation";
import { FaUser } from "react-icons/fa";
import { useSiteData } from "../../redux/siteData";

export default function PlayersOnline() {
  const { playersOnline } = useSiteData();
  const { t } = useTranslation("common");
  return (
    <div className="flex items-center justify-center w-full pt-3 pb-0 space-x-1 text-xs text-altgray-600">
      <FaUser />
      <div className="font-semibold">{playersOnline}</div>
      <div>{t("PLAYERS ONLINE")}</div>
    </div>
  );
}
